import { getMethod } from "../../../../function/helper";

const getAreas = async (id, set) => {
  const response = await getMethod(
    `/address/v1/area/all/1/200?provinceId=0&cityId=${id}`
  );

  if (response) {
    if (response.data) {
      set(() => response.data.area);
    }
  }
};

export default getAreas;
